export const list = [
  { id: '1', text: '13%', title: 'APR' },
  { id: '2', text: 'Monthly', title: 'Re-staking Frequency' },
  { id: '3', text: 'YES', title: 'Earn Transaction Fees' },
  { id: '4', text: 'YES', title: 'EcoIP Royalties' },
  { id: '5', text: 'YES', title: 'Liquidity Pool Reward' },
  { id: '6', text: 'Delegator', title: 'Status' },
];
